import { render, staticRenderFns } from "./assessmentRecordDialog.vue?vue&type=template&id=1db2ed18&scoped=true&"
import script from "./assessmentRecordDialog.vue?vue&type=script&lang=js&"
export * from "./assessmentRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2ed18",
  null
  
)

export default component.exports